import {Typography} from '@mui/material';
import React, {ReactNode} from 'react';
import {EarnedActivityReport, OrdinaryActivityReport} from '../types';
import {formatCurrency} from 'Shared/utilities/FormatMoney';

type CommissionsReportType = EarnedActivityReport | OrdinaryActivityReport;

export type ColumnConfig<T extends CommissionsReportType> = {
  fieldName: keyof T;
  label: string;
  render?: (value: T[keyof T], row: T) => ReactNode;
};

type CommissionReportTableProps<T extends CommissionsReportType> = {
  data: T[];
  columns: ColumnConfig<T>[];
};

export const renderStyledAmount = (value: string) => {
  const amountToRender = formatCurrency(value);

  return amountToRender?.startsWith('-') ? (
    <span className="a360_commissions_reporting__amount--negative">({amountToRender?.replace('-', '')})</span>
  ) : (
    <span>{amountToRender}</span>
  );
};

export const CommissionsReportTable = <T extends CommissionsReportType>({columns, data}: CommissionReportTableProps<T>) => {
  return (
    <div className="a360_commissions_reporting__table-layout">
      {Array.isArray(data) && (
        <table>
            <thead>
              <tr>
                {Array.isArray(columns) &&
                  columns.map(column => (
                    <th scope="col" key={String(column.fieldName)}>
                      <Typography
                        component="h3"
                        sx={{fontWeight: 700}}
                        className="a360-commissions__commission-report-column"
                      >
                        {column.label}
                      </Typography>
                    </th>
                  ))}
              </tr>
            </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={`row-${index}`}>
                {columns.map(col => (
                  <td key={String(col.fieldName)}>
                    {col.render ? col?.render(row[col.fieldName], row) : row[col.fieldName]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
